export default {
  CustomerFunction: {
    PalletText: 'Estimation Pallet Qty',
    WeeklySalesText: 'Est. Weekly Revenue',
    accountCreatedText: 'Account info has been copied',
    accountCreated: 'Account Created',
    ClientCode: 'Client Code',
    Account: 'Account',
    Password: 'Password',
    CurrentApprover: 'Current Approver',
    stepTips1: 'Please enter the customer BP Code',
    stepTips2: 'Please complete Step 4: Create the customer ERP account',
    stepTips3: 'Current user does not have permission to add new ERP user account',
    NETEOM: 'NET/EOM',
    CreditLimit: 'Credit Limit',
    PaymentTerm: 'Payment Term',
    BondLimit: 'Bond Limit',
    FreightMargin: 'Freight Margin',
    credit: 'Credit',
    wallet: 'Wallet',
    bond: 'Bond',
    payment: 'Payment Mode',
    fileTips: 'File upload incomplete. Please upload all required documents.',
    FilesName1: 'Signed Rate Card',
    FilesName2: 'Terms And Condition',
    FilesName3: 'Credit Application',
    FilesName4: 'Customer Analysis',
    FilesName5: 'Inbound Checklist',
    FilesName6: 'Email Confirmation',
    onboardingFiles: 'Onboarding Documents',
    steptitle: 'Progress',
    step1: 'Request Submitted',
    steps1: 'Onboarding request has been createdrelated Docs submitted',
    step2: 'Docs Approved',
    steps2: 'Documents uploaded, pending approval',
    step3: 'Finance Setup',
    steps3: 'Finance Create BP in SAP',
    step4: 'Account Created',
    steps4: 'ERP account provisioned',
    step5: 'Checklist Upload',
    steps5: 'Upload checklist response from customer',
    step6: 'ERP Training',
    steps6: 'Provide ERP training to customer',
    step7: 'IT Solution',
    steps7: 'Come up solutions and implement',
    step8: 'Final Check',
    steps8: 'Send email to customer to confrmall the preparation',
    Stage: 'Stage',
    company: 'Basic Company Information',
    website: 'Website',
    contact: 'Contact Information',
    person: 'Primary Contact Person',
    email: 'Email',
    phone: 'Phone',
    address: 'Business Address',
    business: 'Business Information',
    sku:'SKU volume',
    model:'Business Model',
    customer:'Customer Service',
    start:'Expected Start Date',
    common: {
      CustomerFunction: 'Customer Function List',
      ReturnList:"Return Item List",
      PleaseSelect: 'Please select customer name',
      logisticsNo: 'Tracking No.',
      associatedCode: 'Associated Order Number',
      companyName: 'Company Name',
      AddReturnItem: 'Add Return Item',
      ModifyReturn: 'Modify Return Item',
      Viewwarehouse:"Warehouse Personnel Confirmatio",
      SubmitInformation: 'Submit Information',
      Returndetails: 'Return Item Details',
      Status: 'Status',
      Submitter: 'Submitter',
      SubmissionTime: ' Submission  time',
      ConfirmInformation:"Confirm information",
      Confirmpersonnel:"Confirm Personnel",
      ConfirmTime:"End Date",
      Quantityof:"Good Product Quantity",
      Quantityofdefective:"Defective Product Quantity",
      warehouseAdd:"Warehouse Personnel Confirm Return",
      ApplicationList:"Application List",
      ConfirmList:"Confirmation List",
      AttachmentInformation:"Attachment information",
      ReturnedProducts:"Returned products"
    },
    table: {
      SKUcode: 'SKU',
      GoodQuality: 'Good quality processing',
      HandlingOf: 'Handling of non-conforming products',
    },
  },
};